export default __webpack_public_path__ + "static/media/GraphikBold.66b3ba58.woff2";